"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initEnv = exports.env = void 0;
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('forms:env');
exports.env = {};
let initialized;
function initEnv() {
    return __awaiter(this, void 0, void 0, function* () {
        if (initialized) {
            debug('Env promise already initialized, returning it');
            return initialized;
        }
        debug('Initializing env promise');
        initialized = fetch('/-/env')
            .then(response => {
            if (response.status !== 200) {
                throw response;
            }
            return response.json();
        })
            .then(json => {
            Object.entries(json).forEach(([key, val]) => {
                exports.env[key] = val;
            });
        });
        return initialized;
    });
}
exports.initEnv = initEnv;
